import React from "react";
import "../Css/SideBar_left.css";
import newworldcom from "../images/news.png";
import { Text } from "../containers/Language";

const SideBar = () => {
  return (
    <div className="container_sidebar_courses">
      <article className="card_sidebar_courses">
        <img src={newworldcom} alt="new" />
        <h3>
          <Text tid="Article_dis" />
        </h3>
        <p
          className="card-body-courses"
        >
          <Text tid="Discription_s" />
        </p>
        <a href="https://socialhackersacademy.org/student/do-you-know-how-our-students-united-refugees-during-covid-19/?fbclid=IwAR2ZKLE-XtkqiCrIcy-tngEriHmPKms1JJsBEBn1nFLkIMu7Z-ZK39XjtQM">
          Read More...
        </a>
      </article>



      <article className="card_sidebar_courses">
        <img src={newworldcom} alt="new" />
        <h3>
          <Text tid="Article_dis_1" />
        </h3>
        <p
          className="card-body-courses"
        >
          <Text tid="Discription_p" />
        </p>
        <a href="https://www.peacejameurope.org/to-achive-my-dream">
          Read More...
        </a>
      </article>
    </div>
  );
};

export default SideBar;
